import {
  Required,
  Schema,
  RemoteDataSource,
  TextField
} from "lego-gui-lib/lib";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { ForeignKeyField } from "lego-gui-lib";
import { SANFKOutOfContext } from "../san/schema";
import { Auth } from "../../core/model/auth";

export const SanMatchingSchema = new Schema({
  primaryKey: ["id"],
  defaultSort: { sort: "san.mainNumber", order: "asc" },
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  },
  fields: [
    {
      name: "prefix",
      /*TODO changed this type on NumberField when better solution will be implemented*/
      type: TextField(Required),
      title: t("common:prefix")
    },
    {
      name: "sanRef",
      title: t("hns:san:domain"),
      sort: { field: "san.mainNumber" },
      type: () => SANFKOutOfContext
    }
  ]
});

mainStore.sanMatching = RemoteDataSource.create({
  api: api,
  name: "sanMatching",
  schema: SanMatchingSchema,
  url: "/sanMatchings",
  commons: mainStore.commons
});

export const SanMatchingFK = ForeignKeyField(
  {
    dataSource: mainStore.sanMatching.listDataSource,
    labelField: "prefix",
    valueField: "id",
    minWidth: 70
  },
  Required
);
